import type { ReportDocumentModelV1 } from '../../types/reportContractsV2';
import { hashCanonicalJson } from './reportContractHash';

type DocumentContentWithAssets = {
  assets: readonly { path?: string }[];
};

/**
 * Hash semantic report content while treating an asset's SHA-256—not its GCS
 * locator—as byte identity. This is the single identity rule shared by the
 * builder, artifact loader, publish pipeline and CI matrix.
 */
export function hashReportDocumentSemanticContent<T extends DocumentContentWithAssets>(
  content: T,
): string {
  return hashCanonicalJson({
    ...content,
    assets: content.assets.map(({ path: _path, ...asset }) => asset),
  });
}

export function hashReportDocumentModelContent(document: ReportDocumentModelV1): string {
  const { revisionId: _revisionId, contentHash: _contentHash, ...content } = document;
  return hashReportDocumentSemanticContent(content);
}
